import { useQuery } from '@tanstack/react-query';
import { Offer, OfferWithReminder } from '../types/types';
import { QUERY_KEYS } from '../constants/queryKeys';
import { callPublicAPI } from '../utils/api';
import { pushImpressionsToAnalytics } from '../utils/analytics';
import { useRemindersList } from './useRemindersList';
import { useEffect, useState } from 'react';

export const useAvailableSoonOffers = (location?: string) => {
  const [fireMainQuery, setFireMainQuery] = useState(false);
  const { data: remindersList, isFetched } = useRemindersList();

  useEffect(() => {
    if (isFetched) {
      setFireMainQuery(true);
    }
  }, [isFetched]);

  return useQuery<OfferWithReminder[]>({
    queryKey: [QUERY_KEYS.GET_OFFERS, QUERY_KEYS.GET_OFFERS_VARIATION.COMING_SOON, location],
    queryFn: async () => {
      const offerParams = new URLSearchParams({
        coming_soon: '1',
        sort: 'sort_start_date',
        limit: '6'
      });

      if (location) {
        offerParams.set('location', location);
      }

      const offersRes = await callPublicAPI<Offer[]>('GET', '/offers', offerParams);
      const allOffers = offersRes.data;

      const mergedOffers = allOffers
        .map(offer => ({
          ...offer,
          hasReminder: (remindersList || []).includes(offer.id)
        }))
        .filter(offer => offer.coming_soon == 1);

      pushImpressionsToAnalytics(mergedOffers, 'Uskoro dostupno');
      return mergedOffers;
    },
    enabled: fireMainQuery
  });
};
